import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import ReactSmartTable from "../../../components/Common/ReactSmartTable";
import {
  changeQuery,
  // formatNumbersForTable,
  showInfoMessage,
} from "../../../helpers/utils";
// import CustomMultipleDateRange from "../../../components/CustomMultipleDateRange/CustomMultipleDateRange";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { useHistory } from "react-router-dom";
import ReactTableForm from "../../../components/Common/ReactTableForm";
import queryString from "query-string";
// import PlanOverviewBreadcrumb from "../../AccountManagers/Plans/components/common/PlanOverviewBreadcrumb";
import DynamicFormMultipleFilter from "../../../components/forms/DynamicFormMultipleFilter";
import { Card, CardBody } from "reactstrap";
import ProfitWidgets from "./ProfitWidgets";
import EditVoucherModal from "./EditVaucherModal";

const MediaBuyingPlansProfit = ({
  permissions,
  profit_data,
  filterData,
  onChange,
  closeEditCustomProfit,
  editCustomProfit,
  mediaBuyerVoucherUpdateTrigger,
  handleTableChange,
  profit_loading,
}) => {
  const [dateRange, setDateRange] = React.useState({ 
    date_from: filterData.date_from,
    date_to: filterData.date_from,
  });
  const [customPlanModal, setCustomPlanModal] = React.useState({
    status: false,
    data: null,
  });
  const history = useHistory();
  const [newData, setNewData] = React.useState([]);
  const [data, setData] = React.useState({
    total: {},
    items: [],
  });
  const [columns, setColumns] = React.useState([
    {
      Header: "Offer",
      accessor: "offer_name",
    },
  ]);

  // Colors for status
  const COLORS = {
    DANGER: "#ff7e7e", // Red
    DONE: "#38f76e", // Green
    MEDIUM: "rgba(230, 186, 57, 0.6)", // Yellow
  };

  const handleChangeEditCustomPlan = (i, is_custom, id) => {
    setCustomPlanModal({
      status: true,
      data: {
        ...i,
      },
    });
  };

  const handleCloseEditCustomPlan = () => {
    setCustomPlanModal({ status: false, data: null });
  };

  const checkEmpty = row => {
    if (row.empty) {
      return <div className="" style={{ height: 10 }} />;
    }
  };

  React.useEffect(() => {

    const columns = [
      {
        Header: "Offer",
        src: 'offer_name',
        accessor: row =>
          checkEmpty(row) || row.offer_name || row.client_name || "Total",
      },
      {
        Header: "Buyer",
        src: 'media_buyer',
        // accessor: "media_buyer"
        accessor: row => (row.is_sum ? row.media_buyer : ""),
      },
      {
        Header: "Income",
        src: 'income',
        accessor: "income",
      },
      {
        Header: "Cost",
        src: 'cost',
        accessor: "cost",
      },
      {
        Header: "Voucher",
        src: 'voucher',
        accessor: "voucher",
        accessor: (row, i) => {
          return (
            <>
              {row.can_edit ? (
                <AvForm>
                  <AvField
                    name="voucher"
                    type="number"
                    placeholder="Voucher.."
                    defaultValue={row?.voucher}
                    onChange={e =>
                      handleChangeForm(row?.edit_id, "voucher", e.target.value)
                    }
                  />
                </AvForm>
              ) : row.cashback === "$None" ? (
                "0"
              ) : (
                row.voucher
              )}
            </>
          );
        },
      },
      {
        Header: "Fact cost",
        src: 'fact_cost',
        accessor: "fact_cost",
      },
      {
        Header: "Cashback",
        src: 'cashback',
        accessor: "cashback",
      },
      {
        Header: "Profit",
        src: 'profit',
        accessor: "profit",
      },
      {
        Header: "Profit with Cashback",
        src: 'profit_with_cashback',
        accessor: "profit_with_cashback",
      },
      {
        Header: "KPI, %",
        src: 'kpi',
        accessor: "kpi",
      },
      {
        Header: "Payouts",
        src: 'payout',
        accessor: (row, i) => (
          <div
            style={{
              alignItems: "center",
              verticalAlign: "middle",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <span>{row.payout}</span>
            <StyledAdd
              className={`add-table-new-row ${row?.empty
                  ? "d-none"
                  : row?.is_sum
                    ? "d-none"
                    : row?.is_sum_by_client
                      ? "d-none"
                      : ""
                }`}
              style={{
                display:
                  permissions["is_head_of_mediabuyer"] ||
                    permissions["is_admin"]
                    ? ""
                    : "none",
              }}
            >
              <div
                onClick={
                  row?.can_edit
                    ? () => handleUpdateCustomProfit(row) // () => handleUpdateCustomProfit()
                    : () => handleChangeEditCustomPlan(row, row?.is_custom, row?.id)
                }
              >
                <span>
                  <i
                    className={`mdi ${row?.can_edit ? "mdi-check" : "mdi-lead-pencil"
                      } `}
                  />
                </span>
              </div>
              <div
                className={`${row?.can_edit ? "" : "d-none"}`}
                onClick={() => handleCloseEdit(i)}
              >
                <span>
                  <i className="mdi mdi-close" />
                </span>
              </div>
            </StyledAdd>
          </div>
        ),
        style: {
          maxWidth: 140,
          textAlign: "center",
        },
      },
    ];

    setColumns(columns);

    const elements = [...profit_data.results];
    const total = elements.pop();

    setNewData([]);
    setData({
      total,
      items: elements,
    });

    return () => {
      setNewData([]);
    };
  }, [profit_data]);

  const handleUpdateCustomProfit = () => {
    try {
      let params = {
        ...newData[0],
      };
      let formData = {
        offer_name: params.offer_name,
        media_buyer: params.media_buyer,
        year: params.date__year,
        month: params.date__month,
        voucher: params.voucher,
      };

      if (params.voucher_id) {
        // updateMediaBuyerVoucher(params.voucher_id, formData);
      } else {
        // addMediaBuyerVoucher(formData);
      }

      setNewData([]);
    } catch (e) {
      // console.log(e);
    }
  };

  const handleCloseEdit = i => {
    closeEditCustomProfit(i);
    setNewData([]);
  };

  const handleEditCustomProfit = (i, custom, id) => {
    if (newData.length < 1) {
      editCustomProfit(i);
      setNewData([
        {
          ...profit_data.results[i],
          custom_edit: custom,
        },
      ]);
    } else {
      showInfoMessage("You already have an active field");
    }
  };

  const generatePercentColor = val => {
    switch (true) {
      case val < 50:
        return COLORS["DANGER"];
      case val > 50 && val < 100:
        return COLORS["MEDIUM"];
      case val > 100:
        return COLORS["DONE"];
      default:
        return COLORS["MEDIUM"];
    }
  };

  const cellProps = info => {
    if (info.row.original?.is_sum) {
      return {
        style: {
          fontWeight: "600",
          backgroundColor: "#F9C394",
        },
      };
    }

    if (info.row.original?.is_sum_by_client) {
      return {
        style: {
          fontWeight: "600",
          backgroundColor: "#D4E6CE",
        },
      };
    }

    return {
      style: {
        // ...TABLE.defaultStyleColumns,
      },
    };
  };

  const handleChangeForm = (i, field, data) => {
    let currentNewData = newData;
    currentNewData[0][field] = data;
    setNewData(currentNewData);
  };

  const onDateRangeChange = date => {
    changeQuery(date);
    const nd = {
      date_from: date.start_date,
      date_to: date.end_date,
    };
    setDateRange(date);
    onChange(nd);
  };

  const handleChangeTable = (data) => {
    handleTableChange(data)
  }

  const loading = false;

  return (
    <MediaBuyingPlansOverviewTableStyled>
      <div className="d-flex justify-content-end">
        <DynamicFormMultipleFilter
          onlyMonth
          onFiltersChange={onDateRangeChange} // date
          selectedDate={[]}
          filtered_params={queryString.parse(history.location.search)}
          filtered_by={["offer_id", "account_manager"]}
          dateFilters={[
            {
              value: filterData.date_from,
              isTitle: false,
              plug: "Date range",
              key: "date_range",
            },
          ]}
          style={{ padding: "0.5rem 0", background: "transparent !important" }}
          isTitle={false}
          name="overview"
        />
      </div>
      {customPlanModal.status && (
        <EditVoucherModal
          editData={customPlanModal.data}
          toggle={handleCloseEditCustomPlan}
          isOpen={customPlanModal.status}
          data={customPlanModal.data?.vouchers_list || []}
          mediaBuyerVoucherUpdateTrigger={mediaBuyerVoucherUpdateTrigger}
          permissions={permissions}
          dateRange={dateRange}
        />
      )}

      <ProfitWidgets {...data.total} />
      <Card>
        <CardBody>
          <div>
            <div className="table">
              {/* {!loading ? ( */}
                <ReactTableForm
                  loading={profit_loading}
                  columns={columns}
                  data={data.items}
                  onTableChange={handleChangeTable}
                  getCellProps={cellInfo => cellProps(cellInfo)}
                  isStriped={false}
                  overflow={false}
                />
              {/* ) : (
                <div
                  className="loader-for-react-table justify-content-center"
                  style={{ display: "flex", padding: "45px 0" }}
                >
                  <div
                    className="spinner-border text-primary m-1"
                    role="status"
                  >
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              )} */}
            </div>
          </div>
        </CardBody>
      </Card>
    </MediaBuyingPlansOverviewTableStyled>
  );
};

MediaBuyingPlansProfit.propTypes = {
  permissions: PropTypes.object.isRequired,
  profit_data: PropTypes.any.isRequired,
  profit_loading: PropTypes.bool.isRequired,
  filterData: PropTypes.object.isRequired,
  editCustomProfit: PropTypes.func.isRequired,
  closeEditCustomProfit: PropTypes.func.isRequired,
  handleOverviewTableChange: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  handleTableChange: PropTypes.func,
  mediaBuyerVoucherUpdateTrigger: PropTypes.func.isRequired,
};

const MediaBuyingPlansOverviewTableStyled = styled.div``;

const StyledAdd = styled.div`
  opacity: 0;
  display: flex;
  justify-content: center;
  position: relative;
  align-items: center;

  div {
    color: #fff;
    background: rgba(42, 48, 66, 0.7);
    padding: 9px;
    border-radius: 50%;
    width: 10px;
    height: 10px;
    max-width: 10px;
    max-height: 10px;
    z-index: 99;
    -webkit-transition: all 0.5s ease;
    -moz-transition: all 0.5s ease;
    transition: all 0.5s ease;
    margin: 0 5px;

    span {
      display: flex;
      vertical-align: middle;
      justify-content: center;
      align-items: center;
      width: 0px;
      height: 0px;
    }

    &:hover {
      -webkit-transition: all 0.5s ease;
      -moz-transition: all 0.5s ease;
      transition: all 0.5s ease;
      background: rgba(42, 48, 66, 1);
    }
  }
`;

const DateRangeFormStyled = styled(AvForm)`
  input {
    background-color: transparent !important;
  }
`;

export default MediaBuyingPlansProfit;
